import type { ApiRoute, NoBody, NoQueryParams, NoResponse } from "../api"

export interface CancelSalePathParams {
	inventoryId: string
	offerId: string
}

export const cancelDosSaleRoute: ApiRoute<CancelSalePathParams, NoQueryParams, NoBody, NoResponse> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/dos-offers/${params.offerId}/completions`,
	method: "delete",
	path: "/vehicles/:inventoryId/dos-offers/:offerId/completions",
}
